import Vue from 'vue';
import './plugins/axios';
import App from './App.vue';
import router from './router';
import { storeInstance } from './store';
import { sync } from 'vuex-router-sync';
import './styles/quasar/quasar.styl';
import 'quasar/dist/quasar.ie.polyfills';
import lang from 'quasar/lang/es.js';
import '@fontsource/roboto';
import 'material-icons/iconfont/material-icons.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import filters from './filters.js';
import * as AuthService from '@/services/AuthService.js';
import { initLibTranslation } from '@dinapsis/web-components/dist/lib/i18n/config-locale';
import VueI18n from 'vue-i18n';
import { initializei18n, setLanguage } from './i18n.js';

import {
  Quasar,
  QBtn,
  QIcon,
  QList,
  QItem,
  QItemSection,
  QItemLabel,
  QCard,
  QCardSection,
  QCardActions,
  QDate,
  QInput,
  Ripple,
  QCheckbox,
  Notify,
  QChip,
  QExpansionItem,
  QSelect,
  QSeparator,
  ClosePopup,
  QBadge,
  QLinearProgress,
  Cookies,
  SessionStorage,
  Loading,
  QTooltip,
  QFile
} from 'quasar';
import { getLanguage } from './services/AuthService.js';

Vue.use(Quasar, {
  config: {},
  components: {
    QBtn,
    QIcon,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QCard,
    QCardSection,
    QCardActions,
    QDate,
    QInput,
    QCheckbox,
    QChip,
    QExpansionItem,
    QSelect,
    QSeparator,
    QBadge,
    QLinearProgress,
    QTooltip,
    QFile
  },
  directives: {
    ClosePopup,
    Ripple
  },
  plugins: {
    Cookies,
    Notify,
    SessionStorage,
    Loading
  },
  lang: lang
});

Vue.config.productionTip = false;
filters.create(Vue);

const GlobalEventBus = new Vue();
Vue.prototype.$eventHub = GlobalEventBus;

sync(storeInstance, router);

Vue.config.productionTip = false;

Vue.use(require('@dinapsis/web-components/dist/lib/index'));

Vue.use(VueI18n);

const i18n = initializei18n();
// Lanzamos la inicialización del OpenID si va bien montamos el div de la aplicación si no tendremos que ver que hacemos.
AuthService.init().then(d => {
  if (d) {
    initLibTranslation('es');
    new Vue({
      i18n,
      store: storeInstance,
      router,
      render: h => h(App)
    }).$mount('#app');
    const language = getLanguage();
    setLanguage(language);
  }
}).catch(e => {
  console.log(e);
});
